import {authHeaders, handleResponse} from "./apiUtils";

const baseUrl = process.env.NODE_ENV === "production"
  ? "https://uyygv3wln6.execute-api.eu-west-1.amazonaws.com/default/"
  : "http://localhost:3001/";

async function getClient(id) {
  const response = await fetch(`${baseUrl}clients/${id}`, {
    headers: authHeaders(),
  });
  return handleResponse(response);
}

async function getClients() {
  const response = await fetch(`${baseUrl}clients`, {
    headers: authHeaders(),
  });
  return handleResponse(response);
}

async function saveClient(client) {
  const response = await fetch(`${baseUrl}clients/${client.id || ""}`, {
    method: client.id ? "PUT" : "POST", // POST for create, PUT to update when id already exists.
    headers: authHeaders({ "content-type": "application/json" }),
    body: JSON.stringify(client),
  });
  return handleResponse(response);
}

async function mergeClients(sourceId, targetId, mergeData) {
  const response = await fetch(`${baseUrl}merge-clients`, {
    method: "POST",
    headers: authHeaders({ "content-type": "application/json" }),
    body: JSON.stringify({
      sourceId,
      targetId,
      ...mergeData,
    }),
  });
  return handleResponse(response);
}

export default {
  getClient,
  getClients,
  saveClient,
  mergeClients,
};
